/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./UserLogo.vue?vue&type=template&id=5644e4e1&scoped=true&lang=html&"
import script from "./UserLogo.vue?vue&type=script&lang=js&"
export * from "./UserLogo.vue?vue&type=script&lang=js&"
import style0 from "./UserLogo.vue?vue&type=style&index=0&id=5644e4e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5644e4e1",
  null
  
)

export default component.exports